// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HeartFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HeartFilledIcon" ref={forwardedRef} {...props}>
      <path d="M3.523 4.327c.92-.828 2.18-1.257 3.5-1.006 1.06.202 2.088.827 2.98 1.905.89-1.078 1.918-1.703 2.978-1.904 1.32-.25 2.578.178 3.497 1.007 1.865 1.682 2.295 4.916-.305 7.688l-6.17 6.58-6.167-6.579C1.227 9.243 1.655 6.01 3.523 4.327" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const HeartFilledIcon = /* @__PURE__ */ Object.assign(
  HeartFilledIconComponent,
  { displayName: 'HeartFilledIcon' },
);
